import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Язык чудесный, эсперанто,<br/>
        Тебя прекрасней в мире нет.<br/>
        Звучишь, как дивное бельканто<br/>
        Иль восхитительный сонет.
      </p>
        
      <p class="poem-block mb-3">
        Ты островок добра и света,<br/>
        Твоим теплом вся жизнь согрета,<br/>
        Ты для меня – родимый дом.<br/>
        И мне уютно в доме том.
      </p>
        
      <p class="poem-block mb-3">
        Здесь все уже – друзья и братья,<br/>
        Объединён весь шар земной<br/>
        Мечтой великою одной:<br/>
        Чтобы все люди, без изъятья
      </p>
        
      <p class="poem-block mb-3">
        Понять друг друга бы смогли,<br/>
        И «мир настал бы на земли»…
      </p>
    </div>
    `
  )
}

const itemName = {
  rus: 'Я люблю Эсперанто'
}
const itemDate = {
  rus: '2011 г'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;